<div class="stat-chart" [style.height]="height">
  <!-- Loading State -->
  @if (loading) {
    <div class="stat-chart__loading">
      <div class="stat-chart__loading-shimmer"></div>
    </div>
  }

  <!-- Empty State -->
  @else if (empty || !data) {
    <div class="stat-chart__empty">
      <i class="pi" [ngClass]="emptyIcon"></i>
      <span>{{ emptyMessage | translate }}</span>
    </div>
  }

  <!-- Chart -->
  @else {
    <p-chart
      [type]="chartType"
      [data]="data"
      [options]="chartOptions"
      [style]="{ width: '100%', height: '100%' }"
    ></p-chart>
  }
</div>
